import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { ImageShimmer } from './image-shimmer';

const useStyles = makeStyles({
  container: {
    backgroundImage: 'linear-gradient(45deg, #EBEBEB 25%, transparent 25%), linear-gradient(-45deg, #EBEBEB 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #EBEBEB 75%), linear-gradient(-45deg, transparent 75%, #EBEBEB 75%)',
    backgroundSize: '40px 40px',
    backgroundPositionX: '0px, 0px, 20px, -20px',
    backgroundPositionY: '0px, 20px, -20px, 0px',
    backgroundColor: '#FAFAFA',
    position: 'relative',
    lineHeight: 0,
  },
  mask: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    opacity: 0.4,
    backgroundColor: '#E6E6E6',
    backgroundImage: 'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #47CFFA 50%, #B47CF8 100%)',
    top: 0,
    left: 0,
  },
});


export const ImageWithShimmer = ({ targetImage, showShimmer, className }) => {
  const classes = useStyles();

  return (
    <div className={mergeClasses('target-image-wrapper', classes.container, className)}>
      <img src={targetImage} alt="targetImage" />
      {showShimmer && <ImageShimmer className={mergeClasses('loading-mask', classes.mask)} />}
    </div>
  );
};

ImageWithShimmer.propTypes = {
  targetImage: PropTypes.string.isRequired,
  showShimmer: PropTypes.bool,
  className: PropTypes.string,
};

ImageWithShimmer.defaultProps = {
  showShimmer: false,
  className: '',
};
